import { Pipe, PipeTransform } from '@angular/core'
import { TaskType } from '@wm-front/client/graphql'

declare const $localize: any

@Pipe({
  name: 'taskType',
  standalone: true,
})
export class TaskTypePipe implements PipeTransform {
  /** Transform defect type into localised string
   * @param { TaskType | string } value
   * @param { number} plural
   * @returns { string }
   */
  public transform(value: TaskType | string, plural = 1): string {
    switch (value) {
      case TaskType.Annual:
        return plural <= 1
          ? $localize`:Label | Task type Annual@@taskTypeAnnualLabel:Annuel`
          : $localize`:Label | Task type Annual plural@@taskTypeAnnualsLabel:Annuels`
      case TaskType.Breakdown:
        return plural <= 1
          ? $localize`:Label | Task type Breakdown@@taskTypeBreakdownLabel:Panne`
          : $localize`:Label | Task type Breakdown plural@@taskTypeBreakdownsLabel:Pannes`
      case TaskType.ClientAppointment:
        return plural <= 1
          ? $localize`:Label | Task type ClientAppointment@@taskTypeClientAppointmentLabel:Rendez-vous client`
          : $localize`:Label | Task type ClientAppointment plural@@taskTypeClientAppointmentsLabel:Rendez-vous clients`
      case TaskType.ControlOfficeAppointment:
        return plural <= 1
          ? $localize`:Label | Task type ControlOfficeAppointment@@taskTypeControlOfficeAppointment:Rendez-vous bureau contrôle`
          : $localize`:Label | Task type ControlOfficeAppointment plural@@taskTypeControlOfficeAppointmentsLabel:Rendez-vous bureau contrôle`
      case TaskType.Previsit:
        return plural <= 1
          ? $localize`:Label | Task type Previsit@@taskTypePrevisitLabel:Pré-visite`
          : $localize`:Label | Task type Previsit plural@@taskTypePrevisitsLabel:Pré-visites`
      case TaskType.Quarterly:
        return plural <= 1
          ? $localize`:Label | Task type Quarterly@@taskTypeQuarterlyLabel:Trimestrielle`
          : $localize`:Label | Task type Quarterly plural@@taskTypeQuarterlysLabel:Trimestrielles`
      case TaskType.Regular:
        return plural <= 1
          ? $localize`:Label | Task type Regular@@taskTypeRegularLabel:Régulière`
          : $localize`:Label | Task type Regular plural@@taskTypeRegularsLabel:Régulières`
      case TaskType.Repair:
        return plural <= 1
          ? $localize`:Label | Task type Repair@@taskTypeRepairLabel:Réparation`
          : $localize`:Label | Task type Repair plural@@taskTypeRepairsLabel:Réparations`
      case TaskType.SecurityAudit:
        return plural <= 1
          ? $localize`:Label | Task type SecurityAudit@@taskTypeSecurityAuditLabel:Étude de sécurité`
          : $localize`:Label | Task type SecurityAudit plural@@taskTypeSecurityAuditsLabel:Études de sécurité`
      case TaskType.Semiannual:
        return plural <= 1
          ? $localize`:Label | Task type Semiannual@@taskTypeSemiannualLabel:Semestrielle`
          : $localize`:Label | Task type Semiannual plural@@taskTypeSemiannualsLabel:Semestrielles`
      case TaskType.TrappedPassenger:
        return plural <= 1
          ? $localize`:Label | Task type TrappedPassenger@@taskTypeTrappedPassengerLabel:Passager bloqué`
          : $localize`:Label | Task type TrappedPassenger plural@@taskTypeTrappedPassengersLabel:Passagers bloqués`
      case TaskType.Handover:
        return plural <= 1
          ? $localize`:Label | Task type Handover@@taskTypeHandoverLabel:Handover`
          : $localize`:Label | Task type Handover plural@@taskTypeHandoversLabel:Handovers`
      case TaskType.IotInstallation:
        return plural <= 1
          ? $localize`:Label | Task type IotInstallation@@taskTypeIotInstallationLabel:Installation IOT`
          : $localize`:Label | Task type IotInstallation plural@@taskTypeIotInstallationsLabel:Installations IOT`
      case 'DEFECT':
        return plural <= 1
          ? $localize`:Label | Task type Defect@@taskTypeDefectLabel:Réserve`
          : $localize`:Label | Task type Defect plural@@taskTypeDefectsLabel:Réserves`
      case 'IOT':
        return $localize`:Label | Task type IOT@@taskTypeIOTLabel:IOT`
      case 'ONBOARDING':
        return $localize`:Label | Task type Onboarding@@taskTypeOnboardingLabel:Onboarding`
      default:
        return ''
    }
  }
}
